import { createFileRoute } from '@tanstack/react-router';
import { ReservationsPage } from '@pages/reservations';

/** Reservierungen-Route (/reservations) */
export const Route = createFileRoute('/_authenticated/reservations/')({
  component: ReservationsPage,
});
